/**
 * ホームの「連携アプリケーション」セクションに表示する外部アプリの情報。
 * 開発者ポータルの掲載申請（審査制）を経て GET /connected-apps で取得する
 * （承認済み(approved)のもののみ）。
 */
export interface ConnectedApp {
  id: string;
  name: string;
  url: string;
  iconUrl?: string;
}

/**
 * アイコン画像が無いアプリの頭文字プレースホルダーに使うトーン（1〜4）を
 * id から一意に決定する。タイルとモーダルで同じ色になるよう共通化している。
 */
export function toneForApp(app: ConnectedApp): number {
  let hash = 0;
  for (let i = 0; i < app.id.length; i += 1) {
    hash = (hash * 31 + app.id.charCodeAt(i)) % 4;
  }
  return hash + 1;
}
